export const MIN_DATE = "2017-01-01";
export const RISK_CHART_HEIGHT = 640;
export const MIN_INJURIES_AC_NO = "21";

export const MISSION_GUEST_ORGS = [19, 2];
export const ESTIMATED_ORGS = [19];

export const showMissionGuest = (orgId) => MISSION_GUEST_ORGS.includes(orgId);
export const showEstimated = (orgId) => ESTIMATED_ORGS.includes(orgId);

export const T = {
  en: {
    timePeriod: "Select Time Period",
    startDate: "Start Date",
    endDate: "End Date",
    setNumber: "Set number",
    employee: "Select Employee",
    timeOfDay: "Select time of day",
    training: "View training data",
    read: "View reading data",
    see_null_data: "View Null data for Training and Read",
    incidentType: "Real incident type",
    yellow: "Yellow",
    red: "Red",
    reportingCategory: "PreVent Data",
    nearMiss: "Near miss",
    prevention: "Prevention",
    doubtAboutReporting: "Doubt about reporting",
    faktuel: "Real Incident",
    performance: "T-performance",
    mission: "Mission",
    guest: "Guest",
    estimated: "Estimated rescue time",
    downloadPdf: "Analysis Report PDF",
    downloadPng: "Risk Picture PNG",
    downloadCsv: "Download CSV file",
    clearFilters: "Clear filters",
    showing: "Showing",
    of: "of",
    records: "records",
    rawRecords: "Raw Records",
    beaches: "Beaches",
  },
  dk: {
    timePeriod: "Vælg tidsperiode",
    startDate: "Start Date",
    endDate: "End Date",
    setNumber: "Sætnummer",
    employee: "Vælg medarbejder",
    timeOfDay: "Vælg tidspunkt på døgnet",
    training: "Vis træningsdata",
    read: "Vis læsningsdata",
    see_null_data: "Se Null data for Træning og Læst",
    incidentType: "Faktisk hændelsestype",
    yellow: "Gul",
    red: "Rød",
    reportingCategory: "PreVent Data",
    nearMiss: "Near miss",
    prevention: "Forebyggelse",
    doubtAboutReporting: "Tvivl om rapportering",
    faktuel: "Faktisk hændelse",
    performance: "T-performance",
    mission: "Mission",
    guest: "Gæst",
    estimated: "Estimated rescue time",
    downloadPdf: "Analysis Report PDF",
    downloadPng: "Risk Picture PNG",
    downloadCsv: "Download CSV file",
    showing: "Viser",
    of: "af",
    records: "poster",
    rawRecords: "Rådata",
    beaches: "Vælg beach",
  },
};

export const PDF_TABLE_HEADERS = {
  en: [
    { key: "date", label: "Date" },
    { key: "time", label: "Time" },
    { key: "set", label: "Set no." },
    { key: "card", label: "Actioncard name" },
    { key: "comment", label: "Comment" },
    { key: "employee", label: "Employee name" },
  ],
  dk: [
    { key: "date", label: "Dato" },
    { key: "time", label: "Tid" },
    { key: "set", label: "Sæt nr." },
    { key: "card", label: "Actioncard navn" },
    { key: "comment", label: "Kommentar" },
    { key: "employee", label: "Medarbejder navn" },
  ],
};
